import { css } from '@emotion/react'
import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { SharedModal, Loading } from './'
import { ModalActions, ModalConfirmButton, ModalCancelButton } from './ModalActions'

const SecondaryText = styled.div`
  color: #4a606a;
  font-size: 1.125rem;
  line-height: 33px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

class ConfirmModal extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    handleConfirm: PropTypes.func,
    error: PropTypes.bool,
    loading: PropTypes.bool,
    secondaryText: PropTypes.string,
    confirmButtonText: PropTypes.string,
    denyButtonText: PropTypes.string,
  }

  render() {
    const {
      handleConfirm,
      toggleModal,
      isModalOpen,
      title = 'Delete This Information',
      secondaryText,
      confirmButtonText,
      denyButtonText,
      error,
      loading,
    } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={toggleModal}>
        {secondaryText && (
          <SecondaryText>
            <p>{secondaryText}</p>
          </SecondaryText>
        )}
        {error && (
          <div
            css={css`
              color: #e31e27;
              font-size: 14px;
              line-height: 1.5;
              text-align: center;
              padding: 0.25rem 0 0.75rem 0;
            `}>
            Something went wrong, please try again later.
          </div>
        )}
        {loading ? (
          <Loading />
        ) : (
          <ModalActions>
            <ModalCancelButton type='button' onClick={toggleModal}>
              {denyButtonText}
            </ModalCancelButton>
            <ModalConfirmButton type='button' onClick={handleConfirm}>
              {confirmButtonText}
            </ModalConfirmButton>
          </ModalActions>
        )}
      </SharedModal>
    )
  }
}

export default ConfirmModal
